// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React, { Component } from 'react'
import Typography from '@mui/material/Typography'
import { i18n } from '../../index'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import withActiveStation from '../../station/withActiveStation'
import { availableVitrineProductsQuery } from './vitrineProductQueries'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Paper from '@mui/material/Paper'
import type { Station } from '../../station/stationTypes'
import filter from 'lodash/filter'
import get from 'lodash/get'
import WastePercentageTable from './WastePercentageTable'
import css from './wastePercentage.css'
type Props = {
  activeStation: Station
}
type State = {
  productTypeTab: 'Sweet' | 'Salty'
}

@withActiveStation
class WastePercentage extends Component<Props, State> {
  state = {
    productTypeTab: 'Salty',
  }

  render() {
    const {
      activeStation: { id: stationId },
    } = this.props
    const { productTypeTab } = this.state
    return (
      <div>
        <div className={css.pageTitle}>
          <Typography variant='h6'>{i18n.t('admin.vitrineProducts.wastePercentage.pageTitle')}</Typography>
        </div>
        <Query
          query={availableVitrineProductsQuery}
          variables={{
            stationId,
          }}
          fetchPolicy='network-only'
        >
          {({ loading, error, data }) => (
            <Loader
              {...{
                loading,
                error,
              }}
            >
              <Paper className={css.wastePercentageTable}>
                <Tabs
                  className={css.tabs}
                  indicatorColor='primary'
                  textColor='primary'
                  value={productTypeTab}
                  onChange={(e, value) =>
                    this.setState({
                      productTypeTab: value,
                    })
                  }
                >
                  <Tab
                    disableRipple
                    value='Salty'
                    label={i18n.t('admin.vitrineProducts.products.title.saltyProducts')}
                  />
                  <Tab
                    disableRipple
                    value='Sweet'
                    label={i18n.t('admin.vitrineProducts.products.title.sweetProducts')}
                  />
                </Tabs>
                <WastePercentageTable
                  data={filter(get(data, 'availableVitrineProducts', []), {
                    type: productTypeTab,
                  })}
                  type={productTypeTab}
                />
              </Paper>
            </Loader>
          )}
        </Query>
      </div>
    )
  }
}

export default WastePercentage
